import { c as _c } from "react/compiler-runtime";
import Skeleton from 'react-loading-skeleton';
import styles from './quiz-page-skeleton-loader.module.scss';
export const TabPanelSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles["tab-panel-skeleton"]}><Skeleton className={styles["tab-panel-skeleton__heading"]} /><Skeleton className={styles["tab-panel-skeleton__text"]} count={1.8} /><Skeleton className={styles["tab-panel-skeleton__text"]} count={2.5} /><Skeleton className={styles["tab-panel-skeleton__text"]} count={2.3} />{[1, 2, 3, 4, 5, 6].map(_temp)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
const QuizPageTopSkeleton = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={styles["page-top-skeleton"]}><Skeleton className={styles["page-top-skeleton__button"]} /><Skeleton className={styles["page-top-skeleton__heading"]} /><Skeleton className={styles["page-top-skeleton__text"]} count={3.4} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<div className={styles["page-top-skeleton-tabs-section"]}>{[1, 2, 3, 4, 5, 6, 7].map(_temp2)}</div></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export const QuizPageSkeletonLoader = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div><QuizPageTopSkeleton /><TabPanelSkeleton /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(key) {
  return <div key={key}><Skeleton className={styles["tab-panel-skeleton__question"]} count={2} /><Skeleton className={styles["tab-panel-skeleton__slider"]} /></div>;
}
function _temp2(key) {
  return <Skeleton className={styles["page-top-skeleton-tabs-section__tab"]} key={key} />;
}